import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getOffices = createAsyncThunk(
  "office/getOffices",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/offices?page=${data.page}&perPage=${data.perPage}&search=${data.search}&filter=${data.filter}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to get office.");
    }
  }
);

export const addOffice = createAsyncThunk(
  "office/addOffice",
  async (formData, { rejectWithValue }) => {
    try {
      let url = "admin/offices";
      if (formData.id) {
        url = `admin/offices/${formData.id}`;
      }
      const response = await api.post(url, formData);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to add office.");
    }
  }
);

export const deleteOffice = createAsyncThunk(
  "office/deleteOffice",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.del(`admin/offices/${id}`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to delete office.");
    }
  }
);

export const changeOfficeStatus = createAsyncThunk(
  "office/changeOfficeStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await api.post(`admin/offices/${id}/status`, { status });

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to delete office.");
    }
  }
);
  
export const fetchCountries = createAsyncThunk(
    "office/fetchCountries",
    async (_, { rejectWithValue }) => {
      try {
        const response = await api.get("admin/get-countries");
        const data = response.data.map(row => ({ value: row.id, label: row.name }));
        return data;
      } catch (err) {
        return rejectWithValue(err.response?.data?.message || "Failed to fetch countries");
      }
    }
  );
  
  export const fetchCities = createAsyncThunk(
    "office/fetchCities",
    async (countryId, { rejectWithValue }) => {
      try {
        const response = await api.get(`admin/get-cities?country_id=${countryId}`);
        const data     = response.data.map(row => ({ value: row.id, label: row.name }));
        return data;
      } catch (err) {
        return rejectWithValue(err.response?.data?.message || "Failed to fetch cities");
      }
    }
  );

const officeSlice = createSlice({
  name: "office",
  initialState: {
    list_office: [],
    selected: null,
    countries: [],  
    cities: [],
    loading: false,
    list_loading: false,
    error: null,
    status: "idle",
  },
  reducers: {
    setSelectedOffice(state, action) {
      let payload = action.payload;
      state.selected = {
        id            : payload.id,
        office_name   : payload.office_name,
        office_code   : payload.office_code,
        country_id    : payload.country_id || null,
        city_id       : payload.city_id || null,
        address       : payload.address,
        status        : payload.status,
        mobile_number : payload.mobile_number,
        mobile_country_code : payload.mobile_country_code,
      };
    },
    unsetSelectedOffice(state) {
      state.selected = null;
    },
    resetStatus(state) {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchCountries.fulfilled, (state, action) => {
      state.countries = action.payload;
    })
    .addCase(fetchCities.fulfilled, (state, action) => {
      state.cities = action.payload;
    })
    .addCase(getOffices.pending, (state) => {
      state.list_loading = true;
    })
    .addCase(getOffices.fulfilled, (state, action) => {
      state.list_office = action.payload;
      state.list_loading = false;
    })
    .addCase(getOffices.rejected, (state) => {
      state.list_loading = false;
    })
    .addCase(deleteOffice.pending, (state) => {
      state.loading = true;
    })
    .addCase(deleteOffice.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(deleteOffice.rejected, (state) => {
      state.loading = false;
    })
    .addCase(addOffice.pending, (state) => {
      state.loading = true;
    })
    .addCase(addOffice.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(addOffice.rejected, (state) => {
      state.loading = false;
    })
    .addCase(changeOfficeStatus.pending, (state) => {
      state.loading = true;
    })
    .addCase(changeOfficeStatus.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(changeOfficeStatus.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { setSelectedOffice, unsetSelectedOffice, resetStatus } = officeSlice.actions;
export default officeSlice.reducer;
